import { useState, useEffect } from "react";
import { useAdminApi, toLocalDateStr, fmtMoney, exportXLSX } from "../../adminUtils";
import ExportBar from "./ExportBar";

export default function AttendanceReport() {
  const { API, AUTH } = useAdminApi();
  const today  = toLocalDateStr(new Date());
  const [rangeEnd, setRangeEnd] = useState(today);
  const [data, setData]         = useState([]);
  const [loading, setLoading]   = useState(false);

  const rangeStart = (() => { const d = new Date(`${rangeEnd}T12:00:00`); d.setDate(d.getDate() - 30); return toLocalDateStr(d); })();
  const shiftRange = dir => { const d = new Date(`${rangeEnd}T12:00:00`); d.setDate(d.getDate() + dir * 14); setRangeEnd(toLocalDateStr(d)); };

  useEffect(() => {
    setLoading(true);
    fetch(`${API}/reports/attendance?from=${rangeStart}&to=${rangeEnd}`, { headers: AUTH })
      .then(r => r.json()).then(d => setData(d.classes ?? [])).catch(() => setData([])).finally(() => setLoading(false));
  }, [rangeStart, rangeEnd, API, AUTH]);

  const byTeacher = {};
  for (const c of data) {
    const t = c.teacher || "Unknown";
    if (!byTeacher[t]) byTeacher[t] = [];
    byTeacher[t].push(c);
  }

  const doExport = () => {
    const rows = data.map(c => ({
      Date:      c.date,
      Class:     c.title,
      Teacher:   c.teacher,
      Booked:    c.confirmed,
      Attended:  c.attended,
      Cancelled: c.cancelled,
      Revenue:   c.revenue,
    }));
    exportXLSX("Attendance", rows, `florium-attendance-${rangeStart}-${rangeEnd}.xlsx`);
  };

  return (
    <div>
      <div className="adm-report-range">
        <button onClick={() => shiftRange(-1)}>← Prev</button>
        <span className="adm-range-label">{rangeStart} – {rangeEnd}</span>
        <button onClick={() => shiftRange(1)} disabled={rangeEnd >= today}>Next →</button>
      </div>
      {loading && <p className="adm-loading">Loading…</p>}
      {!loading && <ExportBar onXLSX={doExport} disabled={data.length === 0} />}
      {Object.entries(byTeacher).map(([teacher, classes]) => {
        const totalAttended = classes.reduce((s, c) => s + (c.attended ?? 0), 0);
        const totalRevenue  = classes.reduce((s, c) => s + (c.revenue  ?? 0), 0);
        return (
          <div key={teacher} className="adm-report-teacher">
            <div className="adm-report-teacher-header">
              <span className="adm-report-teacher-name">{teacher}</span>
            </div>
            <table className="adm-report-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Class</th>
                  <th>Booked</th>
                  <th>Attended</th>
                  <th>Cancelled</th>
                  <th>Revenue</th>
                </tr>
              </thead>
              <tbody>
                {classes.map((c, i) => (
                  <tr key={i}>
                    <td>{new Date(c.date + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</td>
                    <td>{c.title}</td>
                    <td>{c.confirmed}</td>
                    <td><strong>{c.attended ?? 0}</strong></td>
                    <td className="adm-report-cancelled">{c.cancelled || 0}</td>
                    <td>{fmtMoney(c.revenue ?? 0)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="adm-report-subtotal">
                  <td colSpan={3}>Subtotal</td>
                  <td><strong>{totalAttended}</strong></td>
                  <td></td>
                  <td>{fmtMoney(totalRevenue)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      })}
    </div>
  );
}
